import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION } from '../Constants';

export const utagTargetedOffersLogin = ({ loyaltyID, email }, state) => {
  let interactionType = {
    eventType: TRACKING_ACTION.INTERACTIONS,
  };

  let extraData = {
    ...(email && { email }),
    ...(loyaltyID && { loyaltyNum: loyaltyID }),
  };

  interactionType.interaction =
    loyaltyID || (!loyaltyID && !email)
      ? `CASlookup:${state}`
      : `emailLookUp:${state}`;

  const interaction = createUserInteraction(interactionType, extraData);

  trackEvent(interaction);
};
